/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import SubUserActionsMenu from './SubUserActionsMenu';

/* ── Power icon (used in ClientActionsMenu) ──────────────── */
export const PowerIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 17.3 19.003">
    <path d="M16.056,5.944a7.65,7.65,0,1,1-10.821,0M10.649,2v8.5" transform="translate(-1.995 -1)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);

/* ── Derive MFA status label from backend booleans ────────── */
export const getMfaStatus = (account) => {
  if (account.mfaEnabled) return 'enabled';
  if (account.mfaRequired) return 'required';
  return 'disabled';
};

/* ── Status pill (client row) ────────────────────────────── */
export const StatusBadge = ({ enabled, hasAccount }) => {
  let label, color, bg, border;
  if (!hasAccount)     { label = 'Non créé';   color = '#6B7280'; bg = '#F3F4F6'; border = '#D1D5DB'; }
  else if (enabled)    { label = 'Activé';     color = '#0AD69F'; bg = '#0AD69F1D'; border = '#0AD69F'; }
  else                 { label = 'Désactivé';  color = '#6B7280'; bg = '#F3F4F6'; border = '#D1D5DB'; }
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '6px', borderRadius: '20px', border: `1px solid ${border}`, backgroundColor: bg }}>
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
      <Typography sx={{ fontSize: '13px', fontWeight: 600, color, lineHeight: 1 }}>{label}</Typography>
    </Box>
  );
};

/* ── AMF badge (sub-user row) ────────────────────────────── */
export const MfaBadge = ({ mfa }) => {
  const cfg = {
    enabled:  { label: 'Activé',  color: '#0AD69F', bg: '#0AD69F1D', border: '#0AD69F' },
    required: { label: 'Requis',  color: '#FEA26F', bg: '#FEA26F17', border: '#FEA26F' },
    disabled: { label: 'Désactivé', color: '#6B7280', bg: '#F3F4F6', border: '#D1D5DB' },
  }[mfa] || { label: '—', color: '#6B7280', bg: '#F3F4F6', border: '#D1D5DB' };
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '6px', borderRadius: '20px', border: `1px solid ${cfg.border}`, backgroundColor: cfg.bg }}>
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 }} />
      <Typography sx={{ fontSize: '12px', fontWeight: 600, color: cfg.color, lineHeight: 1 }}>{cfg.label}</Typography>
    </Box>
  );
};

/* ── Sub-user columns for CustomTable ────────────────────── */
export const subUserColumns = [
  {
    id: 'username',
    label: 'Utilisateur',
    render: (row) => <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#000000' }}>{row.username}</Typography>,
  },
  {
    id: 'enabled',
    label: 'Statut',
    render: (row) => (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '6px', borderRadius: '20px', border: `1px solid ${row.enabled ? '#0AD69F' : '#D1D5DB'}`, backgroundColor: row.enabled ? '#0AD69F1D' : '#F3F4F6' }}>
        <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: row.enabled ? '#0AD69F' : '#6B7280', flexShrink: 0 }} />
        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: row.enabled ? '#0AD69F' : '#6B7280', lineHeight: 1 }}>{row.enabled ? 'Activé' : 'Désactivé'}</Typography>
      </Box>
    ),
  },
  {
    id: 'motif',
    label: 'Motif',
    render: (row) => {
      if (row.enabled || row.errors === undefined) return <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>—</Typography>;
      if (row.errors >= 5) return <Typography sx={{ fontSize: '13px', color: '#d32f2f', fontWeight: 500 }}>5 tentatives de connexion incorrectes</Typography>;
      return <Typography sx={{ fontSize: '13px', color: '#d32f2f', fontWeight: 500 }}>Désactivé par l&apos;administrateur</Typography>;
    },
  },
  {
    id: 'mfa',
    label: 'AMF',
    render: (row) => <MfaBadge mfa={row.mfa} />,
  },
  {
    id: 'action',
    label: 'Action',
    width: 60,
    render: (row) => <SubUserActionsMenu row={row} />,
  },
];
